import { CommonModule } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    OnInit,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {
    FormBuilder
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TableComponent } from '../../shared/components/custom-table/table.component';
import { AlertDialogComponent } from '../../shared/components/dialog/alert-dialog/alert-dialog.component';
import { CustomToastComponent } from '../../shared/components/toast/custom-toast.component';
import { HttpService } from '../../shared/services/http.service';



@Component({
    selector: 'app-event-students',
    standalone: true,
    imports: [
        TableComponent,
        CommonModule
    ],
    templateUrl: './students.component.html',
    styleUrls: ['./students.component.scss']
})
export class EventAttendenceStudentsComponent implements OnInit, AfterViewInit {
    @ViewChild('actionButtons') actionButtonsTemplate!: TemplateRef<any>;
    @ViewChild('actionButtons2') action2ButtonsTemplate!: TemplateRef<any>;

    loading = false;
    viewAttendence = false;
    columns: string[] = ['eventName', 'eventDate', 'eventTime', 'registered', 'attended', 'status',];
    attenColumns: string[] = ['studentName', 'registrationStatus', 'attendanceStatus'];
    data: any[] = [
        {
            eventID: 'EVT001',
            eventName: 'Annual Science Fair',
            eventDate: '2025-10-15',
            eventTime: '10:00 AM - 4:00 PM',
            registered: '25/35',
            attended: '20/25',
            status: 'Upcoming',
        },
        {
            eventID: 'EVT002',
            eventName: 'Art & Craft Workshop',
            eventDate: '2025-07-08',
            eventTime: '9:00 AM - 12:00 PM',
            registered: '40/50',
            attended: '35/40',
            status: 'Ongoing',
        },
        {
            eventID: 'EVT003',
            eventName: 'Math Olympiad',
            eventDate: '2025-06-25',
            eventTime: '11:00 AM - 2:00 PM',
            registered: '60/60',
            attended: '55/60',
            status: 'Already Held',
        },
        {
            eventID: 'EVT004',
            eventName: 'Robotics Challenge',
            eventDate: '2025-07-20',
            eventTime: '2:00 PM - 5:00 PM',
            registered: '30/50',
            attended: '27/30',
            status: 'Upcoming',
        },
        {
            eventID: 'EVT005',
            eventName: 'Cultural Fest',
            eventDate: '2025-07-01',
            eventTime: '10:00 AM - 6:00 PM',
            registered: '100/120',
            attended: '95/100',
            status: 'Already Held',
        },
        {
            eventID: 'EVT006',
            eventName: 'Coding Bootcamp',
            eventDate: '2025-07-08',
            eventTime: '1:00 PM - 5:00 PM',
            registered: '50/70',
            attended: '30/50',
            status: 'Ongoing',
        }
    ];
    attenData: any[] = [
        {
            studentName: 'John Doe',
            registrationStatus: 'Registered',
            attendanceStatus: 'Present'
        },
        {
            studentName: 'Jane Smith',
            registrationStatus: 'Registered',
            attendanceStatus: 'Absent'
        },
        {
            studentName: 'Alice Johnson',
            registrationStatus: 'Not Registered',
            attendanceStatus: 'Present'
        },
        {
            studentName: 'Bob Brown',
            registrationStatus: 'Registered',
            attendanceStatus: 'Present'
        },
        {
            studentName: 'Charlie White',
            registrationStatus: 'Registered',
            attendanceStatus: 'Absent'
        }
    ];






    constructor(
        private dialog: MatDialog,
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private httpService: HttpService,
        private snackBar: MatSnackBar
    ) {
    }

    ngOnInit(): void {

    }

    ngAfterViewInit(): void {
        this.cdr.detectChanges();
    }

    onView(student: any): void {
        this.viewAttendence = true;
    }
    goBack(): void {
        this.viewAttendence = false;
    }

    onToggleAttendance(student: any): void {
        const isMarkingAbsent = student.attendanceStatus === 'Present';
        const actionText = isMarkingAbsent ? 'Mark Absent' : 'Mark Present';
        const newStatus = isMarkingAbsent ? 'Absent' : 'Present';

        const dialogRef = this.dialog.open(AlertDialogComponent, {
            width: '25.438rem',
            data: {
                title: 'Confirm Change',
                message: `Are you sure you want to ${actionText.toLowerCase()} for ${student.studentName}?`,
                okText: actionText,
                cancelText: 'Cancel',
                icon: 'warning',
                submessage: ""
            }
        });

        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                student.attendanceStatus = newStatus;
                this.showSuccessToast(`${student.studentName} has been marked as ${newStatus}.`);

            }
        });
    }

    private showSuccessToast(message: string): void {
        this.snackBar.openFromComponent(CustomToastComponent, {
            data: { message },
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['no-padding-snackbar', 'success-toast']
        });
    }

    private showErrorToast(message: string | null | undefined): void {
        if (!message) return;
        this.snackBar.openFromComponent(CustomToastComponent, {
            data: { message },
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['no-padding-snackbar', 'error-toast']
        });
    }
}